/**
 * InsuranceRisk.jsx — Subtab X
 */

import React from "react";
import { ThreeBubbles } from "../diagrams.jsx";
import { SubtabHeading, GapBlock, SolutionLead, Body, P } from "../SubtabFrame.jsx";

export default function InsuranceRisk() {
  return (
    <article>
      <SubtabHeading roman="X">Insurance and Risk Transfer</SubtabHeading>
      <ThreeBubbles />
      <GapBlock>
        Cyber and malpractice policies may have AI-use exclusions or
        limitations. Unpacking these matters before deployment, not after an
        incident.
      </GapBlock>
      <SolutionLead>
        A coordinated three-policy structure with AI-specific endorsements.
      </SolutionLead>
      <Body>
        <P>
          CoConsoleX carries professional liability (legal malpractice)
          covering its lawyers' work, with explicit coverage for AI-augmented
          legal services. The major legal malpractice carriers — ALAS, Aon,
          Hanover — are now writing this coverage, but it requires negotiation
          and disclosure of the deployment model. Limits are sized to the
          engagement scope; for AmLaw 100 work, $25M per claim with $75M
          aggregate is realistic.
        </P>
        <P>
          CoConsoleX also carries cyber liability with explicit AI deployment
          coverage — notification, forensics, business interruption,
          regulatory defense, and third-party liability. Beazley and Coalition
          both have legal-sector products that can be endorsed for AI
          deployment; AIG and Chubb operate at the higher limits typical for
          AmLaw work.
        </P>
        <P>
          The engaging firm carries its own professional liability and cyber
          coverage, and the engagement letter specifies that each firm is
          responsible for its own work — CoConsoleX is not a vendor for whom
          the engaging firm vouches to its clients, but a co-counsel firm
          whose own coverage stands independently. This is how multi-firm
          engagements have always worked.
        </P>
        <P>
          A tail policy provision is essential — when an engagement ends,
          both firms maintain coverage for claims arising from work done
          during the engagement, typically for six years (the outer limit of
          most state malpractice statutes of repose).
        </P>
        <P>
          CaseSignalHQ publishes a model insurance specification that the
          engaging firm can hand to its risk manager, and that CoConsoleX can
          hand to its broker, so coverage gaps don't open up during
          procurement.
        </P>
      </Body>
    </article>
  );
}
